export default {
  default: () => import("/opt/portal/xyy-web/src/layouts/default.vue")
}